import React, { FC, useState } from 'react'
import { IonModal, IonContent, IonFooter, IonSlides, IonSlide } from '@ionic/react'
import { cartMobx, discountMobx } from 'mobx/mall'
import { format } from '@dt/fe-utils'
import { confirmLayer } from '@utils'
import CouponList from './CouponList'
import { observer } from 'mobx-react'
import { ModalHeader } from '@cps'
import { CodeInputBar } from '../'

import './index.scss'

interface IProps {
  reject?: any;
  resolve?: any;
  tabsType?: string;
}

const CounponModal: FC<IProps> = ({ tabsType, reject = () => { }, resolve = () => {} }) => {
  const counponType = ['single', 'all', tabsType !== 'noPromoCode' && 'promoCode'].filter(Boolean)
  // const counponType = ['single', 'all', 'promoCode'].filter(Boolean)

  const [curSlide, setCurSlide] = useState(0)
  // const [modalPromoCodeCoupons, setModalPromoCodeCoupons] = useState(discountMobx.promoCodeCoupons)
  const slideOpts = {
    initialSlide: curSlide,
    speed: 400
  }
  return (
    <IonModal
      isOpen
      cssClass='mall-coupon-modal tall-modal'
      onDidPresent={() => {
        (document.getElementById('couponSlider') as any)?.update?.()
      }}
    >
      <ModalHeader title={i18n.t('checkout.input_promocode')} onClose={reject} />
      <IonContent scrollX={false} scrollY={false}>
        <div className='coupon-content-box'>
          <CodeInputBar isForbidGiftCard={!0} />
          <div className='coupon-sliders' style={{ paddingTop: 0 }}>
            <IonSlides
              id='couponSlider'
              onIonSlideDidChange={(e: any) => {
                setCurSlide(e.target.swiper.activeIndex)
              }}
              options={slideOpts}
            >
              <IonSlide>
                <CouponList
                  coupons={discountMobx.promoCodeCoupons.map(coupon => {
                    if (coupon.status === 'disable') {
                      return { ...coupon, reason: i18n.t('checkout.promocode_not_optimal') }
                    }
                    return coupon
                  })}
                  // coupons={Object.values(discountMobx.wholeCoupons)}
                  isDelete
                  // isPromoCode
                  onUseClick={(coupon) => {
                    confirmLayer({
                      children: i18n.t('common.confrim_whether_cancel')
                    }).then(() => {
                      const exitCodes = discountMobx.discountAction.promoCodes
                      discountMobx.setPromoCodes(exitCodes.filter(v => v !== coupon.promoCode))
                      // discountMobx.setPromoCodes(exitCodes)
                    }, () => {})
                    // discountMobx.selectPromoCode(coupon.promoCode)
                    // // 处理页面的选中
                    // setModalPromoCodeCoupons(modalPromoCodeCoupons.map(promoCodeCoupon => {
                    //   return {
                    //     ...promoCodeCoupon,
                    //     isSelect: discountMobx.discountAction.promoCodes.includes(promoCodeCoupon.promoCode)
                    //   }
                    // }))
                  }}
                />
              </IonSlide>
            </IonSlides>
          </div>
        </div>
      </IonContent>
      <IonFooter>
        <div className='coupon-footer'>
          <div className='coupon-price'>
            <p>{i18n.t('cart.useDiscountCount', { count: discountMobx.usedPromoCodeCouponsCnt })}</p>
            <p>{i18n.t('cart.discount')}{format.toPrice(cartMobx.cartResult.discountPromoCodeWholePrice + cartMobx.cartResult.discountPromoCodeItemPrice)}</p>
          </div>
          <div className='certain-btn' onClick={() => resolve()}>{i18n.t('common.ok')}</div>
        </div>
      </IonFooter>
    </IonModal>
  )
}

export default observer(CounponModal)
